import getStore from '../store';

export default function getHoveringBucket() {
    const { hoveringBucket } = getStore();
    return hoveringBucket;
}
